<template>
  <div>
    Custom fields
  </div>
</template>

<script>
export default {
  name: 'itemCustomFields',
  methods: {
    loadLis() {

    }
  }
}
</script>

<style scoped>

</style>